import { PropsWithChildren } from 'react';

import { useAuthFeatures } from '@/api/auth/queries';
import { Spinner } from '@/design-system';
import { FeatureFlags, useFeatureFlag } from '@/global-hooks/use-feature-flag-enabled';

import { MaintenancePage } from './maintenance-page';
import { LoadingContainer } from './styled';

export const MaintenanceGate = ({ children }: PropsWithChildren) => {
  const { data, isPending } = useAuthFeatures();
  const posthogMaintenanceEnabled = useFeatureFlag(FeatureFlags.MAINTENANCE);

  if (isPending) {
    return (
      <LoadingContainer role="status" aria-label="Checking service availability">
        <Spinner />
      </LoadingContainer>
    );
  }

  if (data?.maintenanceEnabled === true || posthogMaintenanceEnabled) {
    return <MaintenancePage />;
  }

  return children;
};
